import CityPageTemplate from "../city-template/CityPageTemplate";
import { fullertonConfig } from "./data";

export default function FullertonPage() {
  return <CityPageTemplate config={fullertonConfig} />;
}